import { trpc } from "../trpc";

/**
 * Single-call cross-account copy — the only mutation the
 * CopyToAnotherAccountModal needs for the new design. zsl-api handles
 * generate + sanitize + mint target JWT + execute + reparent under
 * destinationFolderId.
 */
export function useCopyAssetsToAccount() {
  const mutation = trpc.zsl.copyAssetsToAccount.useMutation();

  return {
    copyAssetsToAccount: mutation.mutateAsync,
    isCopying: mutation.isPending,
    error: mutation.error,
  };
}
